import { InputComponent } from "@/shared/components/input.component";
import { OnChanges, Optional, Self, SimpleChanges } from "@angular/core";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import { MatFormFieldAppearance } from "@angular/material/form-field";

@Component({
  selector: "app-input-text",
  templateUrl: "./input-text.component.html",
  styleUrls: ["./input-text.component.scss"],
})
export class InputTextComponent
  extends InputComponent<string>
  implements ControlValueAccessor {
  @Input() mask: string = "";
  @Input() thousandSeparator: string = "";
  @Input() prefix: string = "";
  @Input() decimalMarker: any = ``;
  @Input() sufix: string = "";
  @Input() showMaskTyped: boolean = false;
  @Input() appearance: MatFormFieldAppearance = "fill";
  @Input() isCurrencyInput: boolean = false;
  @Input() type: string = "text";
  @Input() isDisabled: boolean = false;
  @Output() blur = new EventEmitter<void>();

  onBlur() {
    this.blur.emit();
  }

  @Output()
  sufixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() keyEnter: EventEmitter<KeyboardEvent> =
    new EventEmitter<KeyboardEvent>();

  constructor(@Optional() @Self() override ngControl: NgControl) {
    super(ngControl);
  }

  handleKeyEnter(event: any) {
    this.keyEnter.emit(event);
  }

  validateNumberInput(event: KeyboardEvent): void {
    if (this.type === "number") {
      const charCode = event.charCode;
      // check if caracter is number (0-9)
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }
  }
}
